import documentTypeApi from "../../api/DocumentTypeApi";

const state = {
    documentTypeCreated: [],
    documentTypes: [],
    documentTypeMetadata: [],
    documentType: {}

}

const actions = {
    createDocumentType({ commit }, documentType) {
        return new Promise((resolve, reject) => {
            documentTypeApi.store(documentType).then((response) => {
                if (response.status == 201) {
                    resolve(response)
                    commit("CREATE_DOCUMENT_TYPE", response.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },

    getDocumentTypes({ commit }) {
        return new Promise((resolve, reject) => {
            documentTypeApi.all().then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit("SET_DOCUMENT_TYPES", response.data.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    getDocumentTypescount({ commit }) {
        return new Promise((resolve, reject) => {
            documentTypeApi.countDocumentTypes().then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit("SET_DOCUMENT_TYPES", response.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    getStatscount({ commit }) {
        return new Promise((resolve, reject) => {
            documentTypeApi.getStat().then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit("SET_DOCUMENT_TYPES", response.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },

    getDocumentTypeMetadas({ commit }, documentTypeId) {
        return new Promise((resolve, reject) => {
            documentTypeApi.documentTypeMetadata(documentTypeId)
                .then((response) => {
                    if (response.status == 200) {
                        commit("SET_DOCUMENT_TYPE_METADATA", response.data.Metadata)
                        commit("SET_DOCUMENT_TYPE", response.data.DocumentType)
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject((error))
                })
        })
    },

    deleteDocumentType({ commit }, documentTypeId) {
        return new Promise((resolve, reject) => {
            documentTypeApi.delete(documentTypeId)
                .then((response) => {
                    if (response.status == 200) {
                        commit("DELETE_DECUMENT_TYPE", documentTypeId)
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updateDocumentType({ commit }, data) {
        return new Promise((resolve, reject) => {
            documentTypeApi.update(data)
                .then((response) => {
                    if (response.status == 200) {
                        resolve(response)
                        commit("UPDATE_DOCUMENT_TYPE", data.documentType)
                    }

                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}

const mutations = {
    CREATE_DOCUMENT_TYPE: (state, documentType) => state.documentType.unshift(documentType),
    SET_DOCUMENT_TYPES: (state, documentTypes) => (state.documentTypes) = documentTypes,
    SET_DOCUMENT_TYPE_METADATA: (state, documentTypeMetadata) => (state.documentTypeMetadata) = documentTypeMetadata,
    SET_DOCUMENT_TYPE: (state, documentType) => (state.documentType) = documentType,
    DELETE_DECUMENT_TYPE: (state, documentTypeId) => {
        state.documentTypes = state.documentTypes.filter(
            (documentType) => documentType.id !== documentTypeId
        )
    },
    UPDATE_DOCUMENT_TYPE: (state, documentType) => {
        const index = state.documentTypes.findIndex((documentType) => documentType.id === documentType.id)

        if (index !== -1) {
            state.documentTypes.splice(index, 1, documentType)
        }
    }
}

export default { state, actions, mutations };